export default __webpack_public_path__ + "static/media/feather_calendar.fa58347e.svg";